import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { useSAL1011_R01Store, defaultSAL1011_R01Filter, SAL1011_R01Filter } from './Store_SAL1011_R01';
import { getSAL1011_R01HeaderList, getSAL1011_R01DetailList, postSAL1011_R01, patchSAL1011_R01, deleteSAL1011_R01, getSAL1011_R01AllCount, getPdfBlob_SAL1011_R01, getSAL1011_R01ProductResult, getSAL1011_R01One } from './Api_SAL1011_R01';
import { showSuccess, showWarning, showError, ShowSuccessFetch } from 'src/utils/toast/toastUtil';
import useFetchActionbarAuth from 'src/hooks/useFetchActionbarAuth';
import { AgGridReact } from 'ag-grid-react';
import { defaultSAL1011_R01DetailDto, defaultSAL1011_R01HeaderDto, SAL1011_R01DetailDto, SAL1011_R01HeaderDto } from './Dto_SAL1011_R01';
import { fetchDataSetHandler, fetchFilterConfig, gridRefSelectedRowHandler } from 'src/utils/grid/GridHandlerContent';
import { useLoadingSpinnerStore } from 'src/store/util/loadingSpinnerUtil';
import { CompanyDto } from 'src/dtos/company/companyDto';
import { SysCodeDto } from 'src/dtos/code/sysCodeDto';
import { Tab } from 'src/store/useUiuxStore';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';
import { downloadExcel, downloadSettingExcel } from "src/utils/blob/blobUtil";
import { downloadExcel_SAL1011_R01 } from './Api_SAL1011_R01';
import useUiuxStore from 'src/store/useUiuxStore';

import { SAL1011_R01Dto } from './Dto_SAL1011_R01';
import { formatDate, validateString } from 'src/utils/string/stringUtil';
import { calculateDetailAmount, filterDeletedItems, SALES_ORDER_DETAIL_AMOUNT_MAPPING } from 'src/utils/calculation/calculationUtils';
import { validateCustomCd, validateEmployeeCd } from 'src/utils/grid/GridValidateContent';
import { useCommonCodeValidate } from 'src/utils/commonCode/CommonCodeValidateContext';
import {
	buildCommonCodeRequirements,
	SAL1011_R01_HEADER_ROW_VALIDATE,
} from 'src/utils/commonCode/commonCodeRequirementConfig';
import { useQzPrint } from 'src/hooks/useQzPrint';
import qz from 'qz-tray';
import { applyOrderStatusOnly, applyOrderStatusToList, isOrderLocked } from 'src/utils/order/orderUtils';

interface Props {
	gridRef: React.RefObject<AgGridReact<SAL1011_R01HeaderDto> | null>;
	detailGridRef: React.RefObject<AgGridReact<SAL1011_R01DetailDto> | null>;
	
	tabList: Tab[] | undefined;
	setMessage: (message: string) => void;
	
	containerRef: React.RefObject<HTMLDivElement | null>;
	isResizing: React.MutableRefObject<boolean>;
	
}

export const Content_SAL1011_R01 = (props: Props) => {
	const {
		gridRef, detailGridRef,
		tabList, setMessage,
		containerRef,
		isResizing,
		
	} = props;

	const { setLoadingSpinner } = useLoadingSpinnerStore();
	const { validateCommonCodeLists } = useCommonCodeValidate();
	const { setCodeSearchModalProps, } = useUiuxStore();
	const { moneyCdList, vatTypeList, wmsCdList, compCdList, customCdList, employeeCdList, itemCdMap } = useCommonCodeStore();
	const { printPdfFromBlob } = useQzPrint();

	const {
		SAL1011_R01Filter, setSAL1011_R01Filter,
		SAL1011_R01PastFilter, setSAL1011_R01PastFilter,
		SAL1011_R01List, setSAL1011_R01List,
		editSAL1011_R01, setEditSAL1011_R01,
		selectedSAL1011_R01, setSelectedSAL1011_R01,
		SAL1011_R01DetailList, setSAL1011_R01DetailList,
		deletedSAL1011_R01DetailList, setDeletedSAL1011_R01DetailList,
		selectedSAL1011_R01DetailList, setSelectedSAL1011_R01DetailList,
		originalSAL1011_R01DetailList, setOriginalSAL1011_R01DetailList,
		insertSAL1011_R01DetailList, updateSAL1011_R01DetailList, removeSAL1011_R01DetailList,
		addDeletedSAL1011_R01DetailList, removeDeletedSAL1011_R01DetailList,
		allCount, setAllCount,
		detailFetchTrigger, setDetailFetchTrigger,
		productResultComplete, setProductResultComplete,
		initData,
		setScrollTop, setDetailScrollTop,
	} = useSAL1011_R01Store();

	useFetchActionbarAuth("SAL1011_R01");

	// PDF 출력: QZ 연결 시 report1, 미연결/실패 시 새 탭 또는 브라우저 인쇄
	const handlePrintClick = useCallback(async () => {
		if (!selectedSAL1011_R01 || !selectedSAL1011_R01.salesOrderNo) {
			showWarning("출력할 수주를 선택하세요.");
			setMessage("출력할 수주를 선택하세요.");
			return;
		}
		setLoadingSpinner(true);
		try {
			const blob = await getPdfBlob_SAL1011_R01(selectedSAL1011_R01.salesOrderNo);
			if (qz.websocket.isActive()) {
				const ok = await printPdfFromBlob(blob, "report1");
				if (ok) {
					showSuccess("PDF 출력을 완료하였습니다.");
				} else {
					const fileURL = URL.createObjectURL(blob);
					window.open(fileURL, "_blank");
					showWarning(" PDF를 새 탭에서 열었습니다.");
				}
			} else {
				const fileURL = URL.createObjectURL(blob);
				window.open(fileURL, "_blank");
				showSuccess("PDF를 새 탭에서 열었습니다.");
			}
		} catch (error) {
			console.error("PDF 출력 중 오류 발생:", error);
			showError("PDF 출력 중 오류가 발생했습니다.");
			setMessage("PDF 출력 중 오류가 발생했습니다.");
		} finally {
			setLoadingSpinner(false);
		}
	}, [selectedSAL1011_R01, setMessage, printPdfFromBlob, setLoadingSpinner]);

	// DetailTable에서 내장 핸들러 사용으로 변경

	const handleExcelClick = useCallback(async () => {
		if (!selectedSAL1011_R01) {
			showWarning("선택된 수주내역이 없습니다.");
			return;
		}
		setLoadingSpinner(true);

		const response = await downloadExcel_SAL1011_R01(
			'',
			selectedSAL1011_R01.salesOrderNo,
			SAL1011_R01List.length ?? 0
		);

		downloadSettingExcel({ responseData: response.data.data, fileName: '수주정보등록-excel.xlsx' });
		setLoadingSpinner(false);
	}, [selectedSAL1011_R01, SAL1011_R01Filter, SAL1011_R01List]);

	const getParams = (filter: SAL1011_R01Filter) => {

		let orderStatusParam = filter.orderStatus;
		if(filter.orderStatus !== 'Y' && filter.orderStatus !== 'N') {
			orderStatusParam = '';
		}

		const params: Partial<SAL1011_R01Filter> = {
			compCd: filter.compCd || undefined,
			dateRange: filter.dateRange || undefined,
			customCd: filter.customCd || undefined,
			orderStatus: orderStatusParam || undefined,
		};
		return params;
	};

	const renewalAllCount = useCallback(async () => {
		const allCountResponse = await getSAL1011_R01AllCount(getParams(SAL1011_R01Filter));
		setAllCount(allCountResponse.data.data);
		return allCountResponse.data.data;
	}, [SAL1011_R01Filter, setAllCount]);

	// 목록 조회 
	const fetchData = useCallback(async () => {
		setScrollTop(null);
		setDetailScrollTop(null);
		setLoadingSpinner(true);

		const responseData = await getSAL1011_R01HeaderList(
			'',
			getParams(SAL1011_R01Filter),
			SAL1011_R01List.length ?? 0
		);

		let newList = [...responseData.data.data ] as SAL1011_R01HeaderDto[];
		setSAL1011_R01List(newList);

		const processAllCount = await renewalAllCount();
		if (newList && newList.length > 0) {
			gridRefSelectedRowHandler(
				gridRef,
				setSelectedSAL1011_R01,
				() => true, // 항상 첫 번째 행 선택
			);
			setSAL1011_R01PastFilter(SAL1011_R01Filter);
			ShowSuccessFetch(setMessage, `조회가 완료되었습니다. (총 ${newList.length}/${processAllCount}건)`);
			setTimeout(() => setMessage(""), 5000);
		} else {
			showWarning('데이터가 없습니다.');
			handleCreateClick();
		}
		
		setLoadingSpinner(false);
		return responseData;
	}, [SAL1011_R01Filter, SAL1011_R01List, setSAL1011_R01List, setSAL1011_R01PastFilter, setSelectedSAL1011_R01, selectedSAL1011_R01, setScrollTop, setDetailScrollTop]);


	const defaultSAL1011_R01HeaderRow = useCallback(() => {
		const commonResult = validateCommonCodeLists(
			buildCommonCodeRequirements(SAL1011_R01_HEADER_ROW_VALIDATE, {
				compCdList,
				moneyCdList,
				vatTypeList,
				wmsCdList,
			}),
		);
		if (!commonResult.valid) {
			return { ...defaultSAL1011_R01HeaderDto };
		}

		return {
			...defaultSAL1011_R01HeaderDto,
			compCd: compCdList[0].compCd,
			vatType: vatTypeList[0].minorCd,
			moneyCd: moneyCdList[0].minorCd,
			logicCenter: wmsCdList[0].minorCd,
		};
	}, [compCdList, vatTypeList, moneyCdList, wmsCdList, validateCommonCodeLists]);

	const defaultSAL1011_R01DetailRow = useCallback(() => {
		return {
			...defaultSAL1011_R01DetailDto,
			inserted: true,
		}
	}, [defaultSAL1011_R01DetailDto]);

	const fetchOne = useCallback(async () => {
		if (!selectedSAL1011_R01) return;
		setLoadingSpinner(true);
		try {
			const response = await getSAL1011_R01One(selectedSAL1011_R01.salesOrderNo);
			setEditSAL1011_R01(response.data.data);
		} catch (error) {
			console.error("조회 중 오류 발생:", error);
			showError("조회 중 오류가 발생했습니다.");
		}
		setLoadingSpinner(false);
	}, [selectedSAL1011_R01, setEditSAL1011_R01, setLoadingSpinner]);

	
	const fetchDetailList = useCallback(async (salesOrderNo: string) => {
		setDetailScrollTop(null);
		try {
			const responseData = await getSAL1011_R01DetailList(salesOrderNo);
			if (responseData.data.data && responseData.data.data.length > 0) {
				const detailList = responseData.data.data.map((value, idx) => calculateDetailAmount({
					...value,
					valueIndex: value.valueIndex ?? idx + 1,
					orderIndex: value.orderIndex ?? idx + 1,
					orderIndexSeq: value.orderIndexSeq ?? 0,
				}, SALES_ORDER_DETAIL_AMOUNT_MAPPING));
				
				setSAL1011_R01DetailList(detailList);
				setOriginalSAL1011_R01DetailList(detailList);
				setMessage(`${selectedSAL1011_R01?.customNm}의 상세내역 ${detailList.length}건을 조회하였습니다.`);
				setTimeout(() => setMessage(""), 5000);
			} else {
				showError('상세내역이 없습니다.');
				setSAL1011_R01DetailList([]);
				insertSAL1011_R01DetailList([{ ...defaultSAL1011_R01DetailRow() }])
			}
		} catch (error) {
			console.error('상세 조회 중 오류 발생:', error);
			showError('상세내역 조회 중 오류가 발생했습니다.');
		}
	}, [selectedSAL1011_R01, setSAL1011_R01DetailList, setOriginalSAL1011_R01DetailList, setMessage, setDetailScrollTop, insertSAL1011_R01DetailList, defaultSAL1011_R01DetailRow]);

	const checkProductResult = useCallback(async () => {
		if (!editSAL1011_R01?.salesOrderNo) {
			setProductResultComplete(false);
			return;
		}
		
		const response = await getSAL1011_R01ProductResult(editSAL1011_R01?.salesOrderNo || '');
		if (
			response.data.data &&
			response.data.data.transportNo !== null && response.data.data.transportNo !== '') {
			setProductResultComplete(true);
		} else {
			setProductResultComplete(false);
		}
	}, [editSAL1011_R01?.salesOrderNo, setProductResultComplete]);

	// 초기화 함수
	const initContainerData = useCallback(() => {
		initData();
		setDeletedSAL1011_R01DetailList([]);
		setSelectedSAL1011_R01DetailList([]);
		setEditSAL1011_R01({ ...defaultSAL1011_R01HeaderRow() });
	}, [defaultSAL1011_R01HeaderRow, initData, setDeletedSAL1011_R01DetailList, setSelectedSAL1011_R01DetailList, setEditSAL1011_R01]);

	const handleDeleteClick = useCallback(async () => {
		if (!selectedSAL1011_R01) {
			showWarning('선택된 품목이 없습니다.'); return;
		}
		if (window.confirm('정말로 삭제하시겠습니까?')) {
			
			const deleteResponse = await deleteSAL1011_R01(selectedSAL1011_R01.salesOrderNo);

			if (deleteResponse.data.successFlag) {
				showSuccess(`${selectedSAL1011_R01.salesOrderNo} 수주정보 삭제가 완료되었습니다.`)
			} else {
				showError('수주정보 삭제 중 오류가 발생했습니다.');
				return;
			}

			setSAL1011_R01List(SAL1011_R01List.filter(value => value.salesOrderNo !== selectedSAL1011_R01.salesOrderNo));
			setSelectedSAL1011_R01(undefined);
			setSAL1011_R01DetailList([]);

			handleCreateClick();
		}
	}, [selectedSAL1011_R01, SAL1011_R01List]);

	// 신규 생성
	const handleCreateClick = () => {
		setSelectedSAL1011_R01(undefined);
		setProductResultComplete(false);
		setEditSAL1011_R01({ ...defaultSAL1011_R01HeaderRow() });
		setSAL1011_R01DetailList([{ ...defaultSAL1011_R01DetailRow() }]);
		setDeletedSAL1011_R01DetailList([]);
		setSelectedSAL1011_R01DetailList([]);
		setOriginalSAL1011_R01DetailList([]);
		setDetailScrollTop(null);
	};

	const validateInsertData = (header: SAL1011_R01HeaderDto, detailList: SAL1011_R01DetailDto[]) => {
		if (!validateString(header.compCd)) {
			showWarning('사업장을 선택해주세요.', 3000);
			return false;
		}
		if (!validateString(header.customCd)) {
			showWarning('거래처를 선택해주세요.', 3000);
			return false;
		}
		if (!validateCustomCd(header.customCd, customCdList)) {
			showWarning('거래처가 존재하지 않습니다.(입력칸을 더블클릭하거나 엔터키로 세부사항을 열어서 지정해주세요)'); return false;
		}
		if (header.orderDt === undefined) {
			showWarning('수주일자를 입력해주세요.', 3000);
			return false;
		}
		// if (!validateString(header.empNo)) {
		// 	showWarning('담당자를 선택해주세요.', 3000);
		// 	return false;
		// }
		if(validateString(header.empNo)) {
			if (!validateEmployeeCd(header.empNo, employeeCdList)) {
				showWarning('담당자가 존재하지 않습니다.(입력칸을 더블클릭하거나 엔터키로 세부사항을 열어서 지정해주세요)'); return false;
			}
		}
		if (!validateString(header.moneyCd)) {
			showWarning('통화를 선택해주세요.', 3000);
			return false;
		}
		if (!validateString(header.vatType)) {
			showWarning('부가세 유형을 선택해주세요.', 3000);
			return false;
		}
		if (!validateString(header.logicCenter)) {
			showWarning('물류센터를 선택해주세요.', 3000);
			return false;
		}
		if(header.dueDt === undefined) {
			showWarning('납기일자를 입력해주세요.', 3000);
			return false;
		}



		// 삭제되지 않은 상세 행들만 필터링하여 검증
		const activeDetailList = filterDeletedItems(detailList, deletedSAL1011_R01DetailList);

		if (activeDetailList.length === 0) {
			showWarning('상세내역을 입력해주세요.', 3000);
			return false;
		}

		// 상세 데이터 검증 (삭제되지 않은 행들만)
		for (const detail of activeDetailList) {
			if (!detail.itemCd) {
				showWarning('품목코드를 입력해주세요.', 3000);
				return false;
			}
			if (detail.orderQty <= 0) {
				showWarning('수량을 입력해주세요.', 3000);
				return false;
			}
			
			if(detail.cancelQty > detail.orderQty) {
				showWarning('취소수량은 주문량보다 클 수 없습니다.'); return false;
			}
			// if(detail.completeTransport > detail.orderQty) {
			// 	showWarning('출하완료수량은 주문량보다 클 수 없습니다.'); return false;
			// }
			if(detail.cancelQty + detail.completeTransport > detail.orderQty) {
				showWarning('출하완료수량과 취소수량의 합이 주문량보다 클 수 없습니다.'); return false;
			}
			if(detail.inserted === true && detail.completeTransport != 0) {
				showWarning('등록 작업에는 출하완료수량 입력을 할수 없습니다'); return false;
			}
			
			// 중복 품목코드 검증
			const otherDetailList = activeDetailList.filter((_, index) => 
				index !== activeDetailList.findIndex(d => d.valueIndex === detail.valueIndex)
			);
			if (otherDetailList.some(otherDetail => otherDetail.itemCd === detail.itemCd)) {
				showWarning(`중복된 품목코드가 있습니다.\n품목코드: ${detail.itemCd}`, 3000);
				return false;
			}
			if(!itemCdMap.has(detail.itemCd)) {
				showWarning('품목코드가 해당 MES의 품목정보에 존재하지 않습니다.\n품목코드: ' + detail.itemCd); return false;
			}
		}

		return true;
	};

	// 저장(등록/수정)
	const handleSaveClick = useCallback(async () => {
		if (!editSAL1011_R01) return;
		if (isOrderLocked(editSAL1011_R01.orderStatus)) {
			showWarning('출고가 진행된 수주는 수정할 수 없습니다.');
			return;
		}

		// if(productResultComplete) {
		// 	showWarning('생산실적결과가 있는 수주정보는 수정이 불가능합니다.');
		// 	return;
		// }

		// 삭제된 상세 행들을 필터링 후 (수량 - 취소수량) × 단가 반영
		const activeDetailList = filterDeletedItems(SAL1011_R01DetailList, deletedSAL1011_R01DetailList)
			.map((detail) => calculateDetailAmount(detail, SALES_ORDER_DETAIL_AMOUNT_MAPPING));

		// 데이터 검증 (삭제되지 않은 행들만)
		if (!validateInsertData(editSAL1011_R01, SAL1011_R01DetailList)) {
			return;
		}

		setLoadingSpinner(true);

		let processName = '';
		let newDetailList: SAL1011_R01DetailDto[] = [];
		let newHeaderList: SAL1011_R01HeaderDto[] = [];
		let responseData: SAL1011_R01Dto = {
			salesOrderHeaderDto: editSAL1011_R01!,
			salesOrderDetailDtoList: SAL1011_R01DetailList
		};

		try {

			if (selectedSAL1011_R01) {
				// 기존 데이터 수정 시
				newDetailList = activeDetailList; // 이미 필터링된 리스트 사용

				if (newDetailList.length === 0) {
					// 모든 상세 행이 삭제된 경우 → 전체 삭제
					processName = 'delete';
					const deleteResponse = await deleteSAL1011_R01(selectedSAL1011_R01.salesOrderNo);

					newHeaderList = SAL1011_R01List.filter(value => 
						value.salesOrderNo !== selectedSAL1011_R01.salesOrderNo
					);

					if (deleteResponse && deleteResponse.data) {
						if (deleteResponse.data.successFlag) {
							showSuccess('수주내역이 삭제 되었습니다');
							setMessage('수주내역이 삭제 되었습니다');
						} else {
							showError('수주 삭제 중 오류가 발생했습니다.');
							return;
						}
					}
				} else {
					// 일부 상세 행만 삭제된 경우 → PATCH로 수정
					processName = 'patch';
					const patchResponse = await patchSAL1011_R01({
						salesOrderHeaderDto: editSAL1011_R01,
						salesOrderDetailDtoList: newDetailList  // 삭제된 행 제외
					});

					responseData = patchResponse.data.data[0];
					if (editSAL1011_R01!.orderStatus === 'E') {
						newHeaderList = SAL1011_R01List.filter(value => value.salesOrderNo !== editSAL1011_R01!.salesOrderNo);
					} else {
						newHeaderList = SAL1011_R01List.map(value => {
						if (value.salesOrderNo === responseData.salesOrderHeaderDto.salesOrderNo) {
							return responseData.salesOrderHeaderDto;
						}
							return value;
						});
					}

					if (patchResponse?.data?.data && patchResponse.data.successFlag) {
						showSuccess('수주내역이 수정 되었습니다');
						setMessage('수주내역이 수정 되었습니다');
					} else {
						showError('수주 수정 중 오류가 발생했습니다.');
						return;
					}
				}
			} else {
				// 신규 등록
				processName = 'post';
				const postResponse = await postSAL1011_R01({
					salesOrderHeaderDto: editSAL1011_R01,
					salesOrderDetailDtoList: activeDetailList
				});

				responseData = postResponse.data.data[0];
				newHeaderList = [
					...SAL1011_R01List,
					responseData.salesOrderHeaderDto,
				] as SAL1011_R01HeaderDto[];

				if (postResponse?.data?.data && postResponse.data.successFlag) {
					showSuccess('수주내역이 등록 되었습니다');
					setMessage('수주내역이 등록 되었습니다');
				} else {
					showError('수주 등록 중 오류가 발생했습니다.');
					return;
				}
			}

		} catch (error: any) {
			console.log('error :', error.response?.data?.message || error.message);
			showError(error.response?.data?.message || '수주 작업 중 오류가 발생했습니다.');
			return;
		}

		// 저장 후 상태 업데이트
		if (processName === 'delete') {
			setSAL1011_R01List(newHeaderList);
			setSelectedSAL1011_R01(undefined);
			setSAL1011_R01DetailList([]);
			handleCreateClick();
		} else if (processName === 'patch' || processName === 'post') {
			const isCanceledSalesOrder = responseData.salesOrderHeaderDto.orderStatus === 'E' || responseData.salesOrderHeaderDto.orderStatus === 'C';
			if(isCanceledSalesOrder && SAL1011_R01Filter.orderStatus === 'N'){
				newHeaderList = SAL1011_R01List.filter(value => value.salesOrderNo !== responseData.salesOrderHeaderDto.salesOrderNo);
				setSAL1011_R01DetailList([]);
				handleCreateClick();
			}else{
				setSAL1011_R01DetailList(responseData!.salesOrderDetailDtoList);
				setSelectedSAL1011_R01(responseData!.salesOrderHeaderDto);
				setOriginalSAL1011_R01DetailList(responseData!.salesOrderDetailDtoList);
				await fetchOneProcess(responseData.salesOrderHeaderDto.salesOrderNo);
			}
			setSAL1011_R01List(newHeaderList);
		}

		setDeletedSAL1011_R01DetailList([]);
		setSelectedSAL1011_R01DetailList([]);
		setTimeout(() => setMessage(''), 5000);

		setLoadingSpinner(false);

	}, [editSAL1011_R01, selectedSAL1011_R01, SAL1011_R01DetailList, deletedSAL1011_R01DetailList, SAL1011_R01List, setSAL1011_R01List, setSAL1011_R01DetailList, setSelectedSAL1011_R01, setOriginalSAL1011_R01DetailList, setDeletedSAL1011_R01DetailList, setSelectedSAL1011_R01DetailList, setMessage, handleCreateClick]);

	
	const fetchOneProcess = useCallback(async (salesOrderNo: string) => {
		await fetchOne();
		await fetchDetailList(salesOrderNo);
		checkProductResult();
	}, [fetchOne, fetchDetailList, checkProductResult]);

	/** 탭 복귀 시 입력값/그리드는 유지하고 서버 orderStatus만 반영해 잠금 여부를 갱신 */
	const fetchOrderStatus = useCallback(async () => {
		const store = useSAL1011_R01Store.getState();
		const salesOrderNo = store.selectedSAL1011_R01?.salesOrderNo || store.editSAL1011_R01?.salesOrderNo;
		if (!salesOrderNo) return;

		try {
			const response = await getSAL1011_R01One(salesOrderNo);
			const orderStatus = response.data.data?.orderStatus;
			if (orderStatus === undefined) return;

			const latest = useSAL1011_R01Store.getState();
			if (latest.editSAL1011_R01?.salesOrderNo === salesOrderNo) {
				const nextEdit = applyOrderStatusOnly(latest.editSAL1011_R01, orderStatus);
				if (nextEdit && nextEdit !== latest.editSAL1011_R01) {
					setEditSAL1011_R01(nextEdit);
				}
			}
			if (latest.selectedSAL1011_R01?.salesOrderNo === salesOrderNo) {
				const nextSelected = applyOrderStatusOnly(latest.selectedSAL1011_R01, orderStatus);
				if (nextSelected && nextSelected !== latest.selectedSAL1011_R01) {
					setSelectedSAL1011_R01(nextSelected);
				}
			}
			const nextList = applyOrderStatusToList(
				latest.SAL1011_R01List,
				(row) => row.salesOrderNo === salesOrderNo,
				orderStatus,
			);
			if (nextList !== latest.SAL1011_R01List) {
				setSAL1011_R01List(nextList);
			}
		} catch (error) {
			console.error('수주 상태 조회 실패:', error);
		}
	}, [setEditSAL1011_R01, setSelectedSAL1011_R01, setSAL1011_R01List]);

	// HomeContainer는 activeTab만 렌더하므로, 다른 화면으로 가면 이 컴포넌트는 언마운트된다.
	// 다시 들어오면 mount 시점에 orderStatus만 조회한다. fetchOne은 폼/그리드를 덮어써서 사용하지 않는다.
	useEffect(() => {
		fetchOrderStatus();
	}, [fetchOrderStatus]);

	// 수주내역 상세조회
	useEffect(() => {
		const selectedChangeProcess = async () => {
			if (!detailFetchTrigger) return;

			(detailGridRef.current as any)?.clearRange?.();

			if (!selectedSAL1011_R01?.salesOrderNo) {
				setDetailFetchTrigger(false);
				return;
			}

			const salesOrderNo = selectedSAL1011_R01.salesOrderNo;
			await fetchOneProcess(salesOrderNo);
			setDetailFetchTrigger(false);
		}
		selectedChangeProcess();
	}, [selectedSAL1011_R01, fetchOneProcess, detailFetchTrigger, setDetailFetchTrigger]);

	// 상세 데이터가 없을 때 기본 행 추가
	useEffect(() => {
		if (selectedSAL1011_R01 && SAL1011_R01DetailList.length === 0) {
			setSAL1011_R01DetailList([{ ...defaultSAL1011_R01DetailRow() }]);
		}
	}, [selectedSAL1011_R01, SAL1011_R01DetailList.length, setSAL1011_R01DetailList]);

	return {
		handlePrintClick,
		handleExcelClick,
		fetchData,
		defaultSAL1011_R01HeaderRow,
		defaultSAL1011_R01DetailRow,
		initContainerData,
		handleDeleteClick,
		handleCreateClick,
		handleSaveClick,
	};
}; 